//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SIM_PROVIDER_CREATE_REQUEST,
    SIM_PROVIDER_EDIT_REQUEST,
    SIM_PROVIDER_GET_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    simProviderCreateResult,
    simProviderEditResult,
    simProviderGetResult,

} from 'Redux/actions';

function* getSimProvider({ payload }) {
    try {
        let QUERY = `
            query getSimProvider ($id: Int!) {
                result: getSimProvider (id: $id) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(simProviderGetResult(data.result))

    } catch (exc) {
        yield put(simProviderGetResult())
        ExceptionManager(exc, 'Modules/simProviders/views/.components/createEditSimProvider/redux/saga', 'getSimProvider');
    }
}

function* createSimProvider({ payload }) {
    try {
        let QUERY = `
            mutation createSimProvider ($name: String!) {
                result: createSimProvider (name: $name) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(simProviderCreateResult(data?.result))
        } else yield put(simProviderCreateResult())

    } catch (exc) {
        yield put(simProviderCreateResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/simProviders/views/.components/createEditSimProvider/redux/saga', 'createSimProvider');
    }
}

function* updateSimProvider({ payload }) {
    try {
        let QUERY = `
            mutation updateSimProvider ($id: Int!, $name: String!) {
                result: updateSimProvider (id: $id, name: $name) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(simProviderEditResult(data?.result));

    } catch (exc) {
        yield put(simProviderEditResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/simProviders/views/.components/createEditSimProvider/redux/saga', 'updateSimProvider');
    }
}

function* watchSimProvidersRequests() {
    yield takeEvery(SIM_PROVIDER_GET_REQUEST, getSimProvider);
    yield takeEvery(SIM_PROVIDER_CREATE_REQUEST, createSimProvider);
    yield takeEvery(SIM_PROVIDER_EDIT_REQUEST, updateSimProvider);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchSimProvidersRequests)
    ]);
}